import $ from 'jquery';
import stockLoader from '../components/stock-loader';


let options = {};
let params = {};
let colorData = [];
let searchResults = [];
let $modal;
let labels;

function onColorCardSelectorChange() {
    const listIndex = $(this).val();
    $modal.find(options.selectors.colorPickerColorList).find('.modal-b2b-color-picker-list').hide();
    $('#color-list-' + listIndex).show();

    return false;
}

function renderColorCardSelector(cardTypes) {
    let tabsTpl = '';
    cardTypes.forEach((item, index) => {
        tabsTpl += `<option ${index === 0 ? 'selected' : ''} value="${item.index}"> ${item.name}</option>`;
    });

    $modal.find(options.selectors.colorPickerCardSelector).html(tabsTpl);
}

function chooseColor() {
    const $color = $(this);
    const data = $(this).data();

    $color.addClass('loading');

    $.ajax({
        url: `/api/colorpicker/variants?productCode=${data.productCode}&tintingRecipeAxSerialNumber=${data.axSerialNumber}&languageCode=${data.productLanguage}&marketId=${data.marketId}&isb2b=${data.isb2b}`
    })
        .done((res) => {
            $modal.addClass('is-buying');
            $modal.find(options.selectors.colorpickerBuyInner).html(res);

            $(options.selectors.colorpickerBuy).off('click').on('click', function(e) {
                if ($(e.target).is($modal.find(options.selectors.colorpickerBuy))) {
                    $modal.removeClass('is-buying');
                }

                e.preventDefault();
            });

            $(options.selectors.colorPickerModal).find('[data-fancybox]').off('click').on('click', function(e) {
                $.fancybox.open(this, {autoFocus: false, touch: false});
                e.preventDefault();
            });

            stockLoader.init();

        })
        .fail((err) => {
            console.error(err);
        })
        .always(() => {
            $color.removeClass('loading');
        });
}

function renderColor(recipe) {
    return `
        <button class="modal-b2b-color-picker-color js-color-picker-color"
            data-color-chart-id="${recipe.ColorChartId}"
            data-product-language="${params.productLanguage}"
            data-tinting-recipe="${recipe.TintingRecipe}"
            data-ax-serial-number="${recipe.AxSerialNumber}"
            data-product-code="${params.productCode}"
            data-product-ax-key="${params.productAxKey}"
            data-market-id="${params.marketId}"
            data-isb2b="${params.isb2b}">

            <div class="modal-b2b-color-picker-color-tile" style="color: #${recipe.HexCode}">
                <div class="modal-b2b-color-picker-color-icon">
                    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="tint-slash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="svg-inline--fa fa-tint-slash fa-w-20 fa-3x"><path fill="currentColor" d="M320 480c-79.4 0-144-65.5-144-146.1 0-33.4 11.1-59.5 28.4-87.5l-25.3-20c-20.5 32.7-35.1 65.1-35.1 107.4 0 98.4 78.7 178.1 176 178.1 55.5 0 104.9-26 137.1-66.5l-25.7-20.2C405 458.4 365.2 480 320 480zm0-443.9c23.8 77.5 60.1 129.3 89.3 171.1 18.4 26.4 33.7 48.5 43.5 71.9l41.8 32.9c-12-96-101.6-142.2-145.3-289.9C345.2 7.5 332.6 0 320 0c-12.4 0-24.7 7.2-29.2 22.1-11.3 38.2-25.8 69.6-41.2 97l25.4 20c16.5-28.9 32.5-62.4 45-103zm317 449.1L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z" class=""></path></svg>
                    ${labels.labelNoColor}
                </div>
                <div class="modal-b2b-color-picker-color-info">
                    <span class="modal-b2b-color-picker-color-name">${recipe.Name}</span>
                    <span class="modal-b2b-color-picker-color-code">${recipe.TintingRecipe}</span>
                </div>
            </div>
        </button>
    `;
}

function onResetSearch() {
    searchResults = [];
    $modal.removeClass('is-searching');
    $modal.find(options.selectors.colorPickerSearchQuery).val('');
    $modal.find(options.selectors.colorPickerSearchResults).html('');
}

function searchColors() {
    const query = $(this).find(options.selectors.colorPickerSearchQuery);
    const $resultList = $modal.find(options.selectors.colorPickerSearchResults);

    $modal.addClass('is-searching');
    $modal.find(options.selectors.colorPickerSearchReset).one('click', onResetSearch);

    searchResults = {};

    let resultsTpl = '';

    colorData.VisibleColorCharts.forEach((colorChart) => {
        searchResults[colorChart.Name] = []; // one result row per visible color chart
        searchColorChart(searchResults, colorChart, colorChart.Name, query);
    });

    searchResults[colorData.SearchableColorChartResultLabel] = []; // one result row per for searchable color charts
    colorData.SearchableColorCharts.forEach((colorChart) => {
        searchColorChart(searchResults, colorChart, colorData.SearchableColorChartResultLabel, query);
    });

    Object.keys(searchResults).forEach((key) => {
        if (searchResults[key].length) {
            resultsTpl += `<h5 class="modal-b2b-color-picker-list-title">${key}</h5>`;
            searchResults[key].forEach((item) => {
                resultsTpl += item.tpl;
            });
        }
    });

    if (resultsTpl.length) {
        $resultList.html(`<div class="modal-b2b-color-picker-list">${resultsTpl}</div>`);
    } else {
        $resultList.html(`<center><h4>${labels.labelNoResult}</h4></center>`);
    }

    return false;
}

function searchColorChart(results, colorChart, label, query) {
    colorChart.ColorRecipes.forEach((recipe) => {
        const tintingRecipe = recipe.TintingRecipe.toLowerCase();
        const name = recipe.Name === null ? '' : recipe.Name.toLowerCase();
        const description = recipe.Description === null ? '' : recipe.Description.toLowerCase();
        const queryVal = query.val().toLowerCase();

        if (tintingRecipe.includes(queryVal) || name.includes(queryVal) || description.includes(queryVal)) {
            results[label].push({ recipe, tpl: renderColor({ ColorChartId: colorChart.ColorChartId, ...recipe }) });
        }
    });
}

function renderColorList(element, index) {
    const $list = $(`<div id="color-list-${index}" class="modal-b2b-color-picker-list" />`);
    let colorsTpl = '';
    if (element.ColorRecipes.length) {
        element.ColorRecipes.forEach((recipe) => {
            colorsTpl += renderColor({ColorChartId: element.ColorChartId, ...recipe});
        });

        $list.html(colorsTpl);
        $list.hide();

        $modal.find(options.selectors.colorPickerColorList).append($list).find('>:first-child').show();
    }
}

function showColorPicker(e) {
    e.preventDefault();

    const cardTypes = [];

    params = $(this).data();

    $modal.addClass('loading');

    $.fancybox.open({
        src: options.selectors.colorPickerModal, opts: {
        touch: false,
        afterClose: function() {
            $modal.find(options.selectors.colorPickerColorList).html('');
            $modal.find(options.selectors.colorpickerBuyInner).html('');
            $modal.removeClass('is-buying');
            onResetSearch();
        }
    }});

    $.ajax({
        url: `/api/colorpicker/colors?productCode=${params.productCode}&languageCode=${params.productLanguage}&isb2b=${params.isb2b}&marketId=${params.marketId}`
    })
        .done((data) => {
            if (data) {
                colorData = data;
                colorData.VisibleColorCharts.forEach((element, index) => {
                    cardTypes.push({ name: element.Name, index: index});
                    renderColorList(element, index);
                });

                renderColorCardSelector(cardTypes);
            }

        })
        .fail((err) => {
            console.error(err);
        })
        .always(() => {
            $modal.removeClass('loading');
        });
}

function init(opts) {
    const defaults = {
        selectors: {
            colorPickerModal: '#modal-color-picker',
            colorPickerTrigger: '.js-color-picker',
            colorPickerCardSelector: '.js-color-picker-cards-selector',
            colorPickerColor: '.js-color-picker-color',
            colorPickerColorList: '.js-color-picker-color-list',
            colorPickerSearch: '.js-color-picker-search',
            colorPickerSearchQuery: '.js-color-picker-search-query',
            colorPickerSearchReset: '.js-color-picker-search-reset',
            colorPickerSearchResults: '.js-color-picker-search-results',
            colorpickerBuy: '.js-color-picker-buy',
            colorpickerBuyInner: '.js-color-picker-buy-inner'
        }
    };

    options = $.extend(true, defaults, opts);

    $modal = $(options.selectors.colorPickerModal);
    labels = $modal.data();

    $modal.on('change', options.selectors.colorPickerCardSelector, onColorCardSelectorChange);
    $modal.on('click', options.selectors.colorPickerColor, chooseColor);
    $modal.on('submit', options.selectors.colorPickerSearch, searchColors);

    $(options.selectors.colorPickerTrigger).on('click', showColorPicker);
}

export default {
    init
};
